import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
export function getVCRevisionDebugDetails(_ref) {
  var revision = _ref.revision,
    isClean = _ref.isClean,
    abortReason = _ref.abortReason,
    VCEntries = _ref.VCEntries,
    componentsLog = _ref.componentsLog,
    interactionId = _ref.interactionId;
  // Pre-sort VCEntries by time for efficient lookups
  var sortedVCEntries = _toConsumableArray(VCEntries).sort(function (a, b) {
    return a.time - b.time;
  });

  // Pre-calculate max viewport percentage up to each time for efficient lookups
  var maxViewportPercentageAtTime = new Map();
  var maxSoFar = 0;
  var _iterator = _createForOfIteratorHelper(sortedVCEntries),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;
      maxSoFar = Math.max(maxSoFar, entry.vc);
      maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }

    // Helper function to find the biggest previous viewport percentage
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
    // Binary search for the largest time <= targetTime
    var left = 0;
    var right = sortedVCEntries.length - 1;
    var result = -1;
    while (left <= right) {
      var mid = Math.floor((left + right) / 2);
      if (sortedVCEntries[mid].time <= targetTime) {
        result = mid;
        left = mid + 1;
      } else {
        right = mid - 1;
      }
    }
    return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
  };
  var allVcLogs = [];

  // Add regular VC entries
  var _iterator2 = _createForOfIteratorHelper(VCEntries),
    _step2;
  try {
    var _loop = function _loop() {
      var entry = _step2.value;
      var timeLogEntries = componentsLog[entry.time];
      allVcLogs.push({
        time: entry.time,
        viewportPercentage: entry.vc,
        entries: entry.elements.map(function (element) {
          var logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find(function (log) {
            return log.targetName === element;
          });
          return {
            elementName: element,
            type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
            rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
            visible: true,
            attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
            oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
            newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
            ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
          };
        })
      });
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop();
    }

    // Add ignored elements - only process timestamps that have ignored elements
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  for (var _i = 0, _Object$entries = Object.entries(componentsLog); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      timestamp = _Object$entries$_i[0],
      timeLogEntries = _Object$entries$_i[1];
    var ignoredElements = timeLogEntries.filter(function (log) {
      return log.ignoreReason;
    });
    if (ignoredElements.length === 0) {
      continue;
    }
    var time = Number(timestamp);
    var viewportPercentage = getBiggestPreviousViewportPercentage(time);
    allVcLogs.push({
      time: time,
      viewportPercentage: viewportPercentage,
      entries: ignoredElements.map(function (logEntry) {
        return {
          elementName: logEntry.targetName,
          type: logEntry.type,
          rect: logEntry.intersectionRect,
          visible: false,
          attributeName: logEntry.attributeName,
          oldValue: logEntry.oldValue,
          newValue: logEntry.newValue,
          ignoreReason: logEntry.ignoreReason
        };
      })
    });
  }

  // Sort once at the end
  allVcLogs.sort(function (a, b) {
    return a.time - b.time;
  });
  return {
    revision: revision,
    isClean: isClean,
    abortReason: abortReason,
    vcLogs: allVcLogs,
    interactionId: interactionId
  };
}